import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import pipelineEventsSlidingPaneReducer from '../reducers/pipelineEventsSlidingPaneReducer';

const configureStore = (railsProps) => (
  createStore(pipelineEventsSlidingPaneReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
